"use client"
  import __i18nConfig from '@next-translate-root/i18n'
  import AppDirI18nProvider from 'next-translate/AppDirI18nProvider'
  import { useSearchParams as __useSearchParams, useParams as __useParams } from 'next/navigation'
  import { use as __use, Suspense as __Suspense } from 'react'
  import __loadNamespaces from 'next-translate/loadNamespaces'

  ;
import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { HorizontalCenterDiv } from "@/common/divs";
import { HEADER_HEIGHT } from "@/utils/constants";
const AboutUsPage = () => {
    const [isReady, setIsReady] = useState(false);
    useEffect(() => {
        const iframe = document.getElementById("myFrame");
        if (iframe) {
            iframe.addEventListener("load", function () { });
        }
        setTimeout(() => {
            setIsReady(true);
        }, 1500);
    }, []);
    return (<>
      <iframe onLoad={() => {
            setIsReady(true);
        }} title="sobre-nosotros" id="myFrame" src={"https://vee.travel/blog/es-about-us"} width="100%" scrolling="no" style={{
            display: isReady ? "block" : "none",
            height: "calc(4315px + " + HEADER_HEIGHT + ")",
        }}></iframe>

      <HorizontalCenterDiv width="100%" style={{
            height: "calc(100vh - " + HEADER_HEIGHT + ")",
            display: isReady ? "none" : "flex",
        }}>
        <CircularProgress />
      </HorizontalCenterDiv>
    </>);
};
const __Next_Translate__Page__19d9c44de29__ = AboutUsPage;


  export default function __Next_Translate_new__19d9c44de29__(props) {
    const searchParams = __useSearchParams()
    const params = __useParams()
    const detectedLang = params.lang ?? searchParams.get('lang')

    if (detectedLang === 'favicon.ico') return <__Next_Translate__Page__19d9c44de29__ {...props} />

    

    const lang = detectedLang ?? __i18nConfig.defaultLocale
    const config = {
      ...__i18nConfig,
      locale: lang,
      loaderName: 'client /page',
      pathname: '/[lng]/(use-auth)/sobre-nosotros/',
    }

    return (
      <__Suspense fallback={null}>
        <__Next_Translate__child__19d9c44de29__ 
          {...props} 
          config={config} 
          promise={__loadNamespaces({ ...config, loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})), })}
         />
      </__Suspense>
    )
  }

  function __Next_Translate__child__19d9c44de29__({ promise, config, ...props }) {
    const { __lang, __namespaces } = __use(promise);
    const oldNamespaces = globalThis.__NEXT_TRANSLATE__?.namespaces ?? {};
    globalThis.__NEXT_TRANSLATE__ = { lang: __lang, namespaces: { ...oldNamespaces, ...__namespaces }, config };
    return <__Next_Translate__Page__19d9c44de29__ {...props} />;
  }
